if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        TextareaControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-destination', {
        // built-in attributes
        title: 'Card Destination',
        description: 'Custom Card Destination',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'Saznajte više'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                        <p><strong>Description</strong></p>
                        <TextareaControl value={ description } onChange={ onDescriptionChange }></TextareaControl>
                        <br />
                        <p><strong>Button</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <a class="card-destination d-block text-decoration-none">
                    <div class="card-img-container bg-dark shadow rounded-top overflow-hidden mb-2">
                        <img class="cover-image w-100 h-100" src={ image } alt={ alt } />
                    </div>
                    <div class="bg-white shadow rounded-bottom text-center px-4 py-3">
                        <RichText 
                            key="editable" 
                            tagName="h3" 
                            className="h5 mb-1"
                            placeholder="TITLE" 
                            value={ title }
                            onChange={ onTitleChange } />
                        <RichText 
                            key="editable" 
                            tagName="p" 
                            placeholder="+25 putovanja u 12 država" 
                            value={ description }
                            onChange={ onDescriptionChange } />

                        <RichText 
                            key="editable" 
                            tagName="button" 
                            className="btn btn-sm btn-white p-0 text-secondary fw-bold"
                            placeholder="Saznajte više" 
                            value={ viewMore }
                            onChange={ onViewMoreChange } />
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                title,
                description,
                viewMore
            } = attributes;

            return (
                <a href={ link } class="card-destination d-block text-decoration-none">
                    <div class="card-img-container bg-dark shadow rounded-top overflow-hidden mb-2">
                        <img class="lozad cover-image w-100 h-100" data-src={ image } alt={ alt } />
                    </div>
                    <div class="bg-white shadow rounded-bottom text-center px-4 py-3">
                        <h3 class="h5 mb-1">{ title }</h3>
                        <RichText.Content 
                            tagName="p" 
                            value={ description } />

                        <button class="btn btn-sm btn-white p-0 text-secondary fw-bold">{ viewMore }</button>
                    </div>
                </a>
            );
        },
    });
}